import { CURRENT_ENVIROMENT, ENVIROMENTS } from "config/config";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { DEVELOPMENT_LOGIN } from "../../constants/apiRoutes";
import api from "../../services/api";
import { getUserApi, isAuthenticated, login } from "../../services/auth";
import { Form, LogoStyle } from "./login.style";

class Login extends Component {
	state = {
		username: "",
		password: "",
		error: ""
	};

	async componentDidMount() {
		const { history } = this.props;

		const isAutenticado = await isAuthenticated();

		if (isAutenticado) {
			history.push("/home");
			return;
		}

		if (
			process.env.NODE_ENV !== "development" ||
			CURRENT_ENVIROMENT === ENVIROMENTS.DEV_SOE
		) {
			// caso um ambiente diferente de desenvolvimento, chama os metodos
			// responsáveis por acessar a api para resgatar o usuario autenticado
			getUserApi(() => history.push("/home"));
		}
	}

	handleSignIn = async e => {
		e.preventDefault();
		const { username, password } = this.state;
		const { history } = this.props;
		if (!username || !password) {
			this.setState({ error: "Preencha e-mail e senha para continuar!" });
		} else {
			try {
				const response = await api.post(
					`${process.env.PUBLIC_URL}/login`,
					{ username, password }
				);
				login(response.headers.authorization.split(" ")[1]);
				history.push("/home");
			} catch (err) {
				this.setState({
					error:
						"Houve um problema com o login, verifique suas credenciais. T.T"
				});
			}
		}
	};

	handleAuth = () => {
		if (process.env.NODE_ENV !== "development") {
			// Monta a request uri para os ambientes de teste e homologação
			const location = window.location.href.split("#");
			const url = `${location[0]}login`;
			return url;
		}
		// Retorno da request uri para o ambiente de desenvolvimento
		return DEVELOPMENT_LOGIN;
	};

	render() {
		const { error } = this.state;

		return (
			<div
				className="page-holder d-flex align-items-center"
				style={{ height: "100vh" }}
			>
				<div className="container">
					<div className="row align-items-center py-5">
						<div className="col-5 col-lg-7 mx-auto mb-5 mb-lg-0">
							<div className="pr-lg-5">
								<LogoStyle className="img-fluid" />
							</div>
						</div>
						<div className="col-lg-5 px-lg-4">
							<h2 className="text-base text-primary text-uppercase mb-4">
								Gestão de risco e desastres
							</h2>
							<h3 className="mb-4">Acesse o sistema</h3>
							{process.env.NODE_ENV === "development" && (
								<Form
									id="loginForm"
									onSubmit={this.handleSignIn}
									className="mt-4"
								>
									<div className="form-group mb-4">
										<input
											type="text"
											name="username"
											placeholder="Nome de usuário"
											className="form-control border-0 shadow form-control-lg"
											onChange={e =>
												this.setState({
													username: e.target.value
												})
											}
										/>
									</div>
									<div className="form-group mb-4">
										<input
											type="password"
											name="passowrd"
											placeholder="Senha"
											className="form-control border-0 shadow form-control-lg text-violet"
											onChange={e =>
												this.setState({
													password: e.target.value
												})
											}
										/>
									</div>
									<div className="form-group mb-4">
										{error && <p>{error}</p>}
									</div>
									<button
										type="submit"
										className="btn btn-primary shadow px-5"
									>
										Entrar
									</button>
								</Form>
							)}
							{(process.env.NODE_ENV !== "development" ||
								CURRENT_ENVIROMENT === ENVIROMENTS.DEV_SOE) && (
								<a
									href={this.handleAuth()}
									className="btn btn-primary shadow text-white px-5 mt-4"
								>
									Autenticar com SOE
								</a>
							)}
						</div>
					</div>
					<p className="mt-5 mb-0 text-gray-400 text-center">
						Design by{" "}
						<a
							href="https://bootstrapious.com/admin-templates"
							className="external text-gray-400"
						>
							Bootstrapious
						</a>{" "}
						&{" "}
						<a
							href="https://www.gt4w.com.br/"
							className="external text-gray-400"
						>
							GT4W
						</a>
					</p>
				</div>
			</div>
		);
	}
}

export default withRouter(Login);
